import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import { CardBody, Card } from "reactstrap";

import PrintingOptions from "../PrintingOptions";
import Code from "../Code";

import "../../index.css";

function UserCard({ rowData }: any) {
    return (
        <Card
            style={{
                fontSize: "15px",
                overflowY: "auto",
                maxHeight: "70vh",
                minHeight: "70vh",
            }}
        >
            <AvForm>
                <CardBody>
                    <PrintingOptions />
                    <div className="border-footer__clz p-1" />
                    <Code />
                </CardBody>
            </AvForm>
        </Card>
    );
}

export default UserCard;
